import { MenuItem } from '@material-ui/core';
import React from 'react';
import { useDispatch } from 'react-redux';
import { Dispatch } from '../../redux/store';
import { AnalyticsEventKeys } from '../../constants';

type AttachmentMenuItemProps = {
  attachmentLink: string;
  attachmentTitle: string;
};

const AttachmentMenuItem = function AttachmentMenuItem({
  attachmentLink,
  attachmentTitle
}: AttachmentMenuItemProps): React.ReactElement {
  const side = 25;
  const dispatch = useDispatch<Dispatch>();
  const onClick = function onClick(): void {
    dispatch.analytics.sendEvent({
      eventType: AnalyticsEventKeys.DownloadDocumentClicked,
      eventProperties: {
        attachmentLink,
        attachmentTitle
      }
    });
  };
  return (
    <MenuItem
      component='a'
      href={attachmentLink}
      target='_blank'
      rel='noreferrer'
      onClick={onClick}
    >
      <img src='/pdf icon.png' height={side} width={side} alt='pdf-icon' />
      &emsp;
      {attachmentTitle}
    </MenuItem>
  );
};

export default AttachmentMenuItem;
